import React from "react";
import { CheckCircle2, Heart, Users, Sparkles } from "lucide-react";
import { aboutImage } from "../mock";

const points = [
  { icon: Heart, title: "Child-first care", desc: "Every plan is shaped around your child's unique pace and personality." },
  { icon: Sparkles, title: "Holistic approach", desc: "We blend therapy, play, sensory work and parent coaching for lasting growth." },
  { icon: Users, title: "Family partnership", desc: "We coach parents so progress continues at home, every single day." },
];

const chips = ["Personalised plans", "Sensory-friendly rooms", "Parent training", "Progress reviews"];

export default function About() {
  return (
    <section id="about" className="py-16 lg:py-24 bg-gradient-to-b from-transparent to-green-50/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        {/* Image with overlay card */}
        <div className="relative reveal-left">
          <div className="rounded-[28px] overflow-hidden shadow-[0_30px_60px_-20px_rgba(18,43,69,0.25)] aspect-[5/4]">
            <img src={aboutImage} alt="Certified therapist working with a child at Nanhe Kadam Therapy Centre in Patna" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
          </div>
          <div className="absolute -bottom-6 -right-4 lg:right-10 bg-white rounded-2xl shadow-xl px-5 py-4 lg:px-6 lg:py-5 max-w-[230px] reveal-zoom reveal-delay-300">
            <div className="font-serif text-3xl lg:text-4xl text-[#ee6c4d] leading-none">84%</div>
            <div className="mt-2 text-xs lg:text-sm text-slate-500">Parent-loved therapy outcomes</div>
          </div>
          <div className="absolute -top-5 -left-3 w-16 h-16 rounded-full bg-orange-200/60 blur-2xl" />
        </div>

        <div className="reveal-right">
          <div className="flex items-center gap-2 text-[#7cb342] text-sm font-semibold uppercase tracking-[0.2em]">
            <span className="text-lg twinkle">❀</span> About Us
          </div>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl md:text-5xl text-[#122b45] leading-tight">
            A nurturing space where <span className="text-[#ee6c4d]">small steps</span> lead to <span className="stroke-green">big breakthroughs.</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed text-sm sm:text-base">
            Nanhe Kadam Therapy Centre, based in Patna, is dedicated to pediatric therapy and early intervention. Our experienced therapists work hand-in-hand with families to support children with autism, ADHD, speech delays, motor difficulties and learning challenges — using evidence-based, play-led methods that children truly enjoy.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-5">
            {points.map((p, i) => (
              <div key={p.title} className={`reveal reveal-delay-${(i + 1) * 100}`}>
                <div className="w-10 h-10 rounded-xl bg-orange-100 text-[#ee6c4d] flex items-center justify-center">
                  <p.icon className="w-5 h-5" />
                </div>
                <div className="mt-3 font-semibold text-[#122b45]">{p.title}</div>
                <p className="text-sm text-slate-500 mt-1 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {chips.map((c, i) => (
              <div key={c} className={`flex items-center gap-2 text-sm text-[#122b45] reveal reveal-delay-${(i + 1) * 100}`}>
                <CheckCircle2 className="w-4 h-4 text-green-600" />
                {c}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
